export default __webpack_public_path__ + "images/64cebafc9ee1e1a529088e112c485b0d.png";